import React from 'react';

const NotFound = (props) => {
  return <h1>Page Not Found</h1>;
};

NotFound.propTypes = {};

export default NotFound;
